export enum CryptEngine {
  BUFFER = 'buffer',
  NATIVE = 'native',
  LEGACY = 'legacy',
}
